import { View, ViewModel } from "binder";
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class DistrictSelectorViewModel extends SelectorBaseViewModel<DistrictForSelector>{
    protected async loadData(): Promise<DistrictForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDistricts',{});
        return result.Districts.map(q=>{
            let result = new DistrictForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

export class AllDistrictsWithChildrenViewModel extends SelectorBaseViewModel<DistrictForSelector>{
    protected async loadData(): Promise<DistrictForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/AllDistrictsWithChildren',{});
        return result.Districts.map(q=>{
            let result = new DistrictForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

export class DistrictSelectorNoSelfDistrictViewModel extends SelectorBaseViewModel<DistrictForSelector>{
    protected async loadData(): Promise<DistrictForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDistrictsWithoutCurrentDistrict',{});
        return result.Districts.map(q=>{
            let result = new DistrictForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }
}

export class DistrictMultiSelectorViewModel extends MultiSelectorBaseViewModel<DistrictForSelector> {

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.refresh();
    }

    protected async loadData(): Promise<DistrictForSelector[]> {

        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDistricts', {
        });
        return result.Districts.map(q => {
            let r = new DistrictForSelector(this);
            r.id = q.Id;
            r.title = q.Name;
            return r;
        });
    }

}

export class DistrictForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}